interface ISuggestionEntry {
  name: string;
  replacementSpan: { start: number; end: number; length: number };
  kind: string;
  sortText: string;
}
const ToFilter = new Set([
  "AbortController",
  "AbortSignal",
  "AbstractRange",
  "ActiveXObject",
  "AggregateError",
  "AnalyserNode",
  "Animation",
  "AnimationEffect",
  "AnimationEvent",
  "AnimationPlaybackEvent",
  "AnimationTimeline",
  "ApplicationCache",
  "ArrayBuffer",
  "Atomics",
  "Attr",
  "Audio",
  "AudioBuffer",
  "AudioBufferSourceNode",
  "AudioContext",
  "AudioDestinationNode",
  "AudioListener",
  "AudioNode",
  "AudioParam",
  "AudioParamMap",
  "AudioProcessingEvent",
  "AudioScheduledSourceNode",
  "AudioTrack",
  "AudioTrackList",
  "AudioWorklet",
  "AudioWorkletNode",
  "AuthenticatorAssertionResponse",
  "AuthenticatorAttestationResponse",
  "AuthenticatorResponse",
  "BarProp",
  "BaseAudioContext",
  "BeforeUnloadEvent",
  "BhxBrowser",
  "BigInt64Array",
  "BigUint64Array",
  "BiquadFilterNode",
  "Blob",
  "BroadcastChannel",
  "ByteLengthQueuingStrategy",
  "CDATASection",
  "CSS",
  "CSSConditionRule",
  "CSSFontFaceRule",
  "CSSGroupingRule",
  "CSSImportRule",
  "CSSKeyframeRule",
  "CSSKeyframesRule",
  "CSSMediaRule",
  "CSSNamespaceRule",
  "CSSPageRule",
  "CSSRule",
  "CSSRuleList",
  "CSSStyleDeclaration",
  "CSSStyleRule",
  "CSSStyleSheet",
  "CSSSupportsRule",
  "Cache",
  "CacheStorage",
  "CanvasGradient",
  "CanvasPattern",
  "CanvasRenderingContext2D",
  "CaretPosition",
  "ChannelMergerNode",
  "ChannelSplitterNode",
  "CharacterData",
  "ClientRect",
  "ClientRectList",
  "Clipboard",
  "ClipboardEvent",
  "CloseEvent",
  "Comment",
  "CompositionEvent",
  "Console",
  "ConstantSourceNode",
  "ConvolverNode",
  "CountQueuingStrategy",
  "Credential",
  "CredentialsContainer",
  "Crypto",
  "CryptoKey",
  "CryptoKeyPair",
  "CustomElementRegistry",
  "DOMError",
  "DOMException",
  "DOMImplementation",
  "DOMMatrix",
  "DOMMatrixReadOnly",
  "DOMParser",
  "DOMPoint",
  "DOMPointReadOnly",
  "DOMQuad",
  "DOMRect",
  "DOMRectList",
  "DOMRectReadOnly",
  "DOMSettableTokenList",
  "DOMStringList",
  "DOMStringMap",
  "DOMTokenList",
  "DataCue",
  "DataTransfer",
  "DataTransferItem",
  "DataTransferItemList",
  "DataView",
  "DeferredPermissionRequest",
  "DelayNode",
  "DeviceAcceleration",
  "DeviceLightEvent",
  "DeviceMotionEvent",
  "DeviceOrientationEvent",
  "DeviceRotationRate",
  "Document",
  "DocumentFragment",
  "DocumentTimeline",
  "DocumentType",
  "DragEvent",
  "DynamicsCompressorNode",
  "Element",
  "Enumerator",
  "ErrorEvent",
  "EvalError",
  "Event",
  "EventSource",
  "EventTarget",
  "ExtensionScriptApis",
  "External",
  "File",
  "FileList",
  "FileReader",
  "FinalizationRegistry",
  "Float32Array",
  "Float64Array",
  "FocusEvent",
  "FocusNavigationEvent",
  "FormData",
  "GainNode",
  "Gamepad",
  "GamepadButton",
  "GamepadEvent",
  "GamepadHapticActuator",
  "GamepadPose",
  "Geolocation",
  "GeolocationCoordinates",
  "GeolocationPosition",
  "GeolocationPositionError",
  "HTMLAllCollection",
  "HTMLAnchorElement",
  "HTMLAppletElement",
  "HTMLAreaElement",
  "HTMLAudioElement",
  "HTMLBRElement",
  "HTMLBaseElement",
  "HTMLBaseFontElement",
  "HTMLBodyElement",
  "HTMLButtonElement",
  "HTMLCanvasElement",
  "HTMLCollection",
  "HTMLDListElement",
  "HTMLDataElement",
  "HTMLDataListElement",
  "HTMLDetailsElement",
  "HTMLDialogElement",
  "HTMLDirectoryElement",
  "HTMLDivElement",
  "HTMLDocument",
  "HTMLEmbedElement",
  "HTMLFieldSetElement",
  "HTMLFontElement",
  "HTMLFormControlsCollection",
  "HTMLFormElement",
  "HTMLFrameElement",
  "HTMLFrameSetElement",
  "HTMLHRElement",
  "HTMLHeadElement",
  "HTMLHeadingElement",
  "HTMLHtmlElement",
  "HTMLIFrameElement",
  "HTMLImageElement",
  "HTMLInputElement",
  "HTMLLIElement",
  "HTMLLabelElement",
  "HTMLLegendElement",
  "HTMLLinkElement",
  "HTMLMapElement",
  "HTMLMarqueeElement",
  "HTMLMediaElement",
  "HTMLMenuElement",
  "HTMLMetaElement",
  "HTMLMeterElement",
  "HTMLModElement",
  "HTMLOListElement",
  "HTMLObjectElement",
  "HTMLOptGroupElement",
  "HTMLOptionElement",
  "HTMLOptionsCollection",
  "HTMLOutputElement",
  "HTMLParagraphElement",
  "HTMLParamElement",
  "HTMLPictureElement",
  "HTMLPreElement",
  "HTMLProgressElement",
  "HTMLQuoteElement",
  "HTMLScriptElement",
  "HTMLSelectElement",
  "HTMLSlotElement",
  "HTMLSourceElement",
  "HTMLSpanElement",
  "HTMLStyleElement",
  "HTMLTableCaptionElement",
  "HTMLTableCellElement",
  "HTMLTableColElement",
  "HTMLTableDataCellElement",
  "HTMLTableElement",
  "HTMLTableHeaderCellElement",
  "HTMLTableRowElement",
  "HTMLTableSectionElement",
  "HTMLTemplateElement",
  "HTMLTextAreaElement",
  "HTMLTimeElement",
  "HTMLTitleElement",
  "HTMLTrackElement",
  "HTMLUListElement",
  "HTMLUnknownElement",
  "HTMLVideoElement",
  "HashChangeEvent",
  "Headers",
  "History",
  "IDBCursor",
  "IDBCursorWithValue",
  "IDBDatabase",
  "IDBFactory",
  "IDBIndex",
  "IDBKeyRange",
  "IDBObjectStore",
  "IDBOpenDBRequest",
  "IDBRequest",
  "IDBTransaction",
  "IDBVersionChangeEvent",
  "IIRFilterNode",
  "Image",
  "ImageBitmap",
  "ImageBitmapRenderingContext",
  "ImageData",
  "InputDeviceInfo",
  "InputEvent",
  "Int16Array",
  "Int32Array",
  "Int8Array",
  "IntersectionObserver",
  "IntersectionObserverEntry",
  "Intl",
  "KeyboardEvent",
  "KeyframeEffect",
  "ListeningStateChangedEvent",
  "Location",
  "MSAssertion",
  "MSBlobBuilder",
  "MSFIDOCredentialAssertion",
  "MSFIDOSignature",
  "MSFIDOSignatureAssertion",
  "MSGesture",
  "MSGestureEvent",
  "MSGraphicsTrust",
  "MSInputMethodContext",
  "MSMediaKeyError",
  "MSMediaKeyMessageEvent",
  "MSMediaKeyNeededEvent",
  "MSMediaKeySession",
  "MSMediaKeys",
  "MSPointerEvent",
  "MSStream",
  "MediaDeviceInfo",
  "MediaDevices",
  "MediaElementAudioSourceNode",
  "MediaEncryptedEvent",
  "MediaError",
  "MediaKeyMessageEvent",
  "MediaKeySession",
  "MediaKeyStatusMap",
  "MediaKeySystemAccess",
  "MediaKeys",
  "MediaList",
  "MediaQueryList",
  "MediaQueryListEvent",
  "MediaSource",
  "MediaStream",
  "MediaStreamAudioDestinationNode",
  "MediaStreamAudioSourceNode",
  "MediaStreamError",
  "MediaStreamErrorEvent",
  "MediaStreamEvent",
  "MediaStreamTrack",
  "MediaStreamTrackAudioSourceNode",
  "MediaStreamTrackEvent",
  "MessageChannel",
  "MessageEvent",
  "MessagePort",
  "MimeType",
  "MimeTypeArray",
  "MouseEvent",
  "MutationEvent",
  "MutationObserver",
  "MutationRecord",
  "NamedNodeMap",
  "NavigationPreloadManager",
  "Navigator",
  "Node",
  "NodeFilter",
  "NodeIterator",
  "NodeList",
  "Notification",
  "OfflineAudioCompletionEvent",
  "OfflineAudioContext",
  "OffscreenCanvas",
  "OffscreenCanvasRenderingContext2D",
  "Option",
  "OscillatorNode",
  "OverconstrainedError",
  "OverflowEvent",
  "PageTransitionEvent",
  "PannerNode",
  "Path2D",
  "PaymentAddress",
  "PaymentMethodChangeEvent",
  "PaymentRequest",
  "PaymentRequestUpdateEvent",
  "PaymentResponse",
  "PerfWidgetExternal",
  "Performance",
  "PerformanceEntry",
  "PerformanceMark",
  "PerformanceMeasure",
  "PerformanceNavigation",
  "PerformanceNavigationTiming",
  "PerformanceObserver",
  "PerformanceObserverEntryList",
  "PerformanceResourceTiming",
  "PerformanceTiming",
  "PeriodicWave",
  "PermissionRequest",
  "PermissionRequestedEvent",
  "PermissionStatus",
  "Permissions",
  "Plugin",
  "PluginArray",
  "PointerEvent",
  "PopStateEvent",
  "ProcessingInstruction",
  "ProgressEvent",
  "PromiseRejectionEvent",
  "Proxy",
  "PublicKeyCredential",
  "PushManager",
  "PushSubscription",
  "PushSubscriptionOptions",
  "RTCCertificate",
  "RTCDTMFSender",
  "RTCDTMFToneChangeEvent",
  "RTCDataChannel",
  "RTCDataChannelEvent",
  "RTCDtlsTransport",
  "RTCDtlsTransportStateChangedEvent",
  "RTCDtmfSender",
  "RTCError",
  "RTCErrorEvent",
  "RTCIceCandidate",
  "RTCIceCandidatePairChangedEvent",
  "RTCIceGatherer",
  "RTCIceGathererEvent",
  "RTCIceTransport",
  "RTCIceTransportStateChangedEvent",
  "RTCIdentityAssertion",
  "RTCPeerConnection",
  "RTCPeerConnectionIceErrorEvent",
  "RTCPeerConnectionIceEvent",
  "RTCRtpReceiver",
  "RTCRtpSender",
  "RTCRtpTransceiver",
  "RTCSctpTransport",
  "RTCSessionDescription",
  "RTCSrtpSdesTransport",
  "RTCSsrcConflictEvent",
  "RTCStatsEvent",
  "RTCStatsProvider",
  "RTCStatsReport",
  "RTCTrackEvent",
  "RadioNodeList",
  "RandomSource",
  "Range",
  "RangeError",
  "ReadableStream",
  "ReadableStreamDefaultController",
  "ReadableStreamDefaultReader",
  "ReadableStreamReader",
  "ReferenceError",
  "Reflect",
  "Request",
  "ResizeObserverEntry",
  "ResizeObserverSize",
  "Response",
  "SVGAElement",
  "SVGAngle",
  "SVGAnimateElement",
  "SVGAnimateMotionElement",
  "SVGAnimateTransformElement",
  "SVGAnimatedAngle",
  "SVGAnimatedBoolean",
  "SVGAnimatedEnumeration",
  "SVGAnimatedInteger",
  "SVGAnimatedLength",
  "SVGAnimatedLengthList",
  "SVGAnimatedNumber",
  "SVGAnimatedNumberList",
  "SVGAnimatedPreserveAspectRatio",
  "SVGAnimatedRect",
  "SVGAnimatedString",
  "SVGAnimatedTransformList",
  "SVGAnimationElement",
  "SVGCircleElement",
  "SVGClipPathElement",
  "SVGComponentTransferFunctionElement",
  "SVGCursorElement",
  "SVGDefsElement",
  "SVGDescElement",
  "SVGElement",
  "SVGElementInstance",
  "SVGElementInstanceList",
  "SVGEllipseElement",
  "SVGFEBlendElement",
  "SVGFEColorMatrixElement",
  "SVGFEComponentTransferElement",
  "SVGFECompositeElement",
  "SVGFEConvolveMatrixElement",
  "SVGFEDiffuseLightingElement",
  "SVGFEDisplacementMapElement",
  "SVGFEDistantLightElement",
  "SVGFEDropShadowElement",
  "SVGFEFloodElement",
  "SVGFEFuncAElement",
  "SVGFEFuncBElement",
  "SVGFEFuncGElement",
  "SVGFEFuncRElement",
  "SVGFEGaussianBlurElement",
  "SVGFEImageElement",
  "SVGFEMergeElement",
  "SVGFEMergeNodeElement",
  "SVGFEMorphologyElement",
  "SVGFEOffsetElement",
  "SVGFEPointLightElement",
  "SVGFESpecularLightingElement",
  "SVGFESpotLightElement",
  "SVGFETileElement",
  "SVGFETurbulenceElement",
  "SVGFilterElement",
  "SVGForeignObjectElement",
  "SVGGElement",
  "SVGGeometryElement",
  "SVGGradientElement",
  "SVGGraphicsElement",
  "SVGImageElement",
  "SVGLength",
  "SVGLengthList",
  "SVGLineElement",
  "SVGLinearGradientElement",
  "SVGMarkerElement",
  "SVGMaskElement",
  "SVGMatrix",
  "SVGMetadataElement",
  "SVGNumber",
  "SVGNumberList",
  "SVGPathElement",
  "SVGPathSeg",
  "SVGPathSegArcAbs",
  "SVGPathSegArcRel",
  "SVGPathSegClosePath",
  "SVGPathSegCurvetoCubicAbs",
  "SVGPathSegCurvetoCubicRel",
  "SVGPathSegCurvetoCubicSmoothAbs",
  "SVGPathSegCurvetoCubicSmoothRel",
  "SVGPathSegCurvetoQuadraticAbs",
  "SVGPathSegCurvetoQuadraticRel",
  "SVGPathSegCurvetoQuadraticSmoothAbs",
  "SVGPathSegCurvetoQuadraticSmoothRel",
  "SVGPathSegLinetoAbs",
  "SVGPathSegLinetoHorizontalAbs",
  "SVGPathSegLinetoHorizontalRel",
  "SVGPathSegLinetoRel",
  "SVGPathSegLinetoVerticalAbs",
  "SVGPathSegLinetoVerticalRel",
  "SVGPathSegList",
  "SVGPathSegMovetoAbs",
  "SVGPathSegMovetoRel",
  "SVGPatternElement",
  "SVGPoint",
  "SVGPointList",
  "SVGPolygonElement",
  "SVGPolylineElement",
  "SVGPreserveAspectRatio",
  "SVGRadialGradientElement",
  "SVGRect",
  "SVGRectElement",
  "SVGSVGElement",
  "SVGScriptElement",
  "SVGStopElement",
  "SVGStringList",
  "SVGStyleElement",
  "SVGSwitchElement",
  "SVGSymbolElement",
  "SVGTSpanElement",
  "SVGTextContentElement",
  "SVGTextElement",
  "SVGTextPathElement",
  "SVGTextPositioningElement",
  "SVGTitleElement",
  "SVGTransform",
  "SVGTransformList",
  "SVGUnitTypes",
  "SVGUseElement",
  "SVGViewElement",
  "SVGZoomAndPan",
  "SVGZoomEvent",
  "SafeArray",
  "ScopedCredential",
  "ScopedCredentialInfo",
  "Screen",
  "ScreenOrientation",
  "ScriptProcessorNode",
  "SecurityPolicyViolationEvent",
  "Selection",
  "ServiceUIFrameContext",
  "ServiceWorker",
  "ServiceWorkerContainer",
  "ServiceWorkerMessageEvent",
  "ServiceWorkerRegistration",
  "ShadowRoot",
  "SharedArrayBuffer",
  "SharedWorker",
  "SourceBuffer",
  "SourceBufferList",
  "SpeechGrammar",
  "SpeechGrammarList",
  "SpeechRecognition",
  "SpeechRecognitionAlternative",
  "SpeechRecognitionError",
  "SpeechRecognitionErrorEvent",
  "SpeechRecognitionEvent",
  "SpeechRecognitionResult",
  "SpeechRecognitionResultList",
  "SpeechSynthesis",
  "SpeechSynthesisErrorEvent",
  "SpeechSynthesisEvent",
  "SpeechSynthesisUtterance",
  "SpeechSynthesisVoice",
  "StaticRange",
  "StereoPannerNode",
  "Storage",
  "StorageEvent",
  "StorageManager",
  "StyleMedia",
  "StyleSheet",
  "StyleSheetList",
  "SubtleCrypto",
  "SyncManager",
  "SyntaxError",
  "Text",
  "TextDecoder",
  "TextDecoderStream",
  "TextEncoder",
  "TextEncoderStream",
  "TextEvent",
  "TextMetrics",
  "TextTrack",
  "TextTrackCue",
  "TextTrackCueList",
  "TextTrackList",
  "TimeRanges",
  "Touch",
  "TouchEvent",
  "TouchList",
  "TrackEvent",
  "TransformStream",
  "TransformStreamDefaultController",
  "TransitionEvent",
  "TreeWalker",
  "TypeError",
  "UIEvent",
  "URIError",
  "URL",
  "URLSearchParams",
  "Uint16Array",
  "Uint32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "VBArray",
  "VRDisplay",
  "VRDisplayCapabilities",
  "VRDisplayEvent",
  "VREyeParameters",
  "VRFieldOfView",
  "VRFrameData",
  "VRPose",
  "VTTCue",
  "VTTRegion",
  "ValidityState",
  "VarDate",
  "VideoPlaybackQuality",
  "VideoTrack",
  "VideoTrackList",
  "VisualViewport",
  "WSH",
  "WScript",
  "WaveShaperNode",
  "WeakRef",
  "WebAssembly",
  "WebAuthentication",
  "WebAuthnAssertion",
  "WebGL2RenderingContext",
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLContextEvent",
  "WebGLFramebuffer",
  "WebGLObject",
  "WebGLProgram",
  "WebGLQuery",
  "WebGLRenderbuffer",
  "WebGLRenderingContext",
  "WebGLSampler",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLSync",
  "WebGLTexture",
  "WebGLTransformFeedback",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  "WebKitCSSMatrix",
  "WebKitPoint",
  "WebSocket",
  "WheelEvent",
  "Window",
  "Worker",
  "Worklet",
  "WritableStream",
  "WritableStreamDefaultController",
  "WritableStreamDefaultWriter",
  "XMLDocument",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload",
  "XMLSerializer",
  "XPathEvaluator",
  "XPathExpression",
  "XPathResult",
  "XSLTProcessor",
  "addEventListener",
  "applicationCache",
  "caches",
  "captureEvents",
  "clientInformation",
  "closed",
  "confirm",
  "createImageBitmap",
  "crypto",
  "customElements",
  "defaultStatus",
  "departFocus",
  "devicePixelRatio",
  "dispatchEvent",
  "doNotTrack",
  "event",
  "external",
  "focus",
  "frameElement",
  "frames",
  "getComputedStyle",
  "getMatchedCSSRules",
  "getSelection",
  "history",
  "importScripts",
  "indexedDB",
  "innerHeight",
  "innerWidth",
  "isSecureContext",
  "length",
  "localStorage",
  "location",
  "locationbar",
  "matchMedia",
  "menubar",
  "moveBy",
  "moveTo",
  "msContentScript",
  "msWriteProfilerMark",
  "name",
  "navigator",
  "offscreenBuffering",
  "onabort",
  "onafterprint",
  "onanimationcancel",
  "onanimationend",
  "onanimationiteration",
  "onanimationstart",
  "onauxclick",
  "onbeforeprint",
  "onbeforeunload",
  "onblur",
  "oncancel",
  "oncanplay",
  "oncanplaythrough",
  "onchange",
  "onclick",
  "onclose",
  "oncompassneedscalibration",
  "oncontextmenu",
  "oncuechange",
  "ondblclick",
  "ondevicelight",
  "ondevicemotion",
  "ondeviceorientation",
  "ondeviceorientationabsolute",
  "ondrag",
  "ondragend",
  "ondragenter",
  "ondragexit",
  "ondragleave",
  "ondragover",
  "ondragstart",
  "ondrop",
  "ondurationchange",
  "onemptied",
  "onended",
  "onerror",
  "onfocus",
  "ongamepadconnected",
  "ongamepaddisconnected",
  "ongotpointercapture",
  "onhashchange",
  "oninput",
  "oninvalid",
  "onkeydown",
  "onkeypress",
  "onkeyup",
  "onlanguagechange",
  "onload",
  "onloadeddata",
  "onloadedmetadata",
  "onloadend",
  "onloadstart",
  "onlostpointercapture",
  "onmessage",
  "onmessageerror",
  "onmousedown",
  "onmouseenter",
  "onmouseleave",
  "onmousemove",
  "onmouseout",
  "onmouseover",
  "onmouseup",
  "onmousewheel",
  "onmsgesturechange",
  "onmsgesturedoubletap",
  "onmsgestureend",
  "onmsgesturehold",
  "onmsgesturestart",
  "onmsgesturetap",
  "onmsinertiastart",
  "onmspointercancel",
  "onmspointerdown",
  "onmspointerenter",
  "onmspointerleave",
  "onmspointermove",
  "onmspointerout",
  "onmspointerover",
  "onmspointerup",
  "onoffline",
  "ononline",
  "onorientationchange",
  "onpagehide",
  "onpageshow",
  "onpause",
  "onplay",
  "onplaying",
  "onpointercancel",
  "onpointerdown",
  "onpointerenter",
  "onpointerleave",
  "onpointermove",
  "onpointerout",
  "onpointerover",
  "onpointerup",
  "onpopstate",
  "onprogress",
  "onratechange",
  "onreadystatechange",
  "onrejectionhandled",
  "onreset",
  "onresize",
  "onscroll",
  "onsecuritypolicyviolation",
  "onseeked",
  "onseeking",
  "onselect",
  "onselectionchange",
  "onselectstart",
  "onstalled",
  "onstorage",
  "onsubmit",
  "onsuspend",
  "ontimeupdate",
  "ontoggle",
  "ontouchcancel",
  "ontouchend",
  "ontouchmove",
  "ontouchstart",
  "ontransitioncancel",
  "ontransitionend",
  "ontransitionrun",
  "ontransitionstart",
  "onunhandledrejection",
  "onunload",
  "onvolumechange",
  "onvrdisplayactivate",
  "onvrdisplayblur",
  "onvrdisplayconnect",
  "onvrdisplaydeactivate",
  "onvrdisplaydisconnect",
  "onvrdisplayfocus",
  "onvrdisplaypointerrestricted",
  "onvrdisplaypointerunrestricted",
  "onvrdisplaypresentchange",
  "onwaiting",
  "onwheel",
  "open",
  "opener",
  "orientation",
  "origin",
  "outerHeight",
  "outerWidth",
  "pageXOffset",
  "pageYOffset",
  "parent",
  "performance",
  "personalbar",
  "postMessage",
  "print",
  "prompt",
  "queueMicrotask",
  "releaseEvents",
  "removeEventListener",
  "resizeBy",
  "resizeTo",
  "screen",
  "screenLeft",
  "screenTop",
  "screenX",
  "screenY",
  "scroll",
  "scrollBy",
  "scrollTo",
  "scrollX",
  "scrollY",
  "scrollbars",
  "self",
  "sessionStorage",
  "speechSynthesis",
  "status",
  "statusbar",
  "stop",
  "styleMedia",
  "toString",
  "toolbar",
  "top",
  "visualViewport",
  "webkitCancelAnimationFrame",
  "webkitConvertPointFromNodeToPage",
  "webkitConvertPointFromPageToNode",
  "webkitRTCPeerConnection",
  "webkitRequestAnimationFrame",
  "webkitURL",
]);

export type TTsProvideCompletionItems = (
  this: unknown,
  model: import("monaco-editor").editor.IReadOnlyModel,
  position: import("monaco-editor").Position,
  context: import("monaco-editor").languages.CompletionContext,
  token: import("monaco-editor").CancellationToken,
) => Promise<import("monaco-editor").languages.CompletionList | undefined>;

/**
 * Filters the list of suggestions returned by the typescript service. In
 * particular, filters some global suggestions, such as `CryptoKeyPair` or
 * `MediaDeviceInfo`.
 * @param superMethod Super method that was overridden.
 * @param model Current editor model.
 * @param position Current cursor position.
 * @param context Current completion context.
 * @param token Token to cancel the completion.
 * @returns List of completion items.
 */
export async function tsProvideFilteredGlobalCompletionItems(
  this: unknown,
  _superMethod: TTsProvideCompletionItems,
  model: import("monaco-editor").editor.IReadOnlyModel,
  position: import("monaco-editor").Position,
  _context: import("monaco-editor").languages.CompletionContext,
  _token: import("monaco-editor").CancellationToken,
): Promise<import("monaco-editor").languages.CompletionList | undefined> {
  const wordInfo = model.getWordUntilPosition(position);
  const wordRange = new monaco.Range(
    position.lineNumber,
    wordInfo.startColumn,
    position.lineNumber,
    wordInfo.endColumn,
  );
  const resource = model.uri;
  const offset = model.getOffsetAt(position);

  const worker = await (this as Record<"_worker", (uri: import("monaco-editor").Uri) => unknown>)._worker(resource);
  // @ts-expect-error We are using an untyped internal API...
  const info = await worker.getCompletionsAtPosition(resource.toString(), offset);

  if (!info || model.isDisposed()) {
    return;
  }

  // Do not show top level suggestions unless the user requests them explicitly; or has typed at least some characters
  const triggeredByCtrlSpace = window.event && window.event instanceof KeyboardEvent && window.event.key === " ";
  const filterSome = info.isGlobalCompletion && !triggeredByCtrlSpace && wordInfo.endColumn - wordInfo.startColumn < 4;

  const entries = filterSome
    ? info.entries.filter((entry: ISuggestionEntry) => !ToFilter.has(entry.name))
    : info.entries;

  const suggestions = entries.map((entry: ISuggestionEntry) => {
    let range = wordRange;
    if (entry.replacementSpan) {
      const p1 = model.getPositionAt(entry.replacementSpan.start);
      const p2 = model.getPositionAt(entry.replacementSpan.start + entry.replacementSpan.length);
      range = new monaco.Range(p1.lineNumber, p1.column, p2.lineNumber, p2.column);
    }
    return {
      insertText: entry.name,
      // @ts-expect-error Internal untyped API
      kind: monacoExtras.vs.language.typescript.TsMode.SuggestAdapter.convertKind(entry.kind),
      label: entry.name,
      position: position,
      range: range,
      sortText: entry.sortText,
      uri: resource,
    };
  });

  return {
    incomplete: filterSome,
    suggestions: suggestions,
  };
}
